import { Component, OnInit } from '@angular/core';
import { Module } from 'app/models/module.model';
import { Role } from 'app/models/role.model';
import { RoleModule } from 'app/models/roleModule.model';
import { ModuleService } from 'app/services/module.service';
import { RoleService } from 'app/services/role.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss']
})
export class PermissionComponent implements OnInit {
  roles: Role[] = [];
  errors: [];
  success: boolean;
  currentRole: Role = new Role();
  allModules: Module[];
  selectedModules: RoleModule[];
  choixModules: number[];


  constructor(private roleService: RoleService, private moduleService: ModuleService, private _userService: UserService) { }

  ngOnInit(): void {
    this.getRoles();
    this.getModules();
  }

  getRoles(){
    this.roleService.getRoles().subscribe((roles) => {
      this.roles = roles;
    });
  }

  getModules(){
    this.moduleService.getModules().subscribe((modules) => {
      this.allModules = modules;
    });
  }

  getRoleModules(){
    this.roleService.getRoleModules(this.currentRole.id).subscribe((modules) => {
      this.selectedModules = modules;
      this.choixModules = [];
      this.selectedModules.forEach((module) => {
        this.choixModules.push(module.module_id);
      });
    });
  }

  edit(id){
    this.errors = [];
    this.selectedModules = [];

    if (this.roles[0].id === 0) {
        this.roles.shift();
    }
    if (this.currentRole.id == id) {
        this.currentRole = new Role();
    }
    else {
        this.roleService.getRole(id).subscribe((role) => {
            // GlobalFunctions.topScroll('role-' + id);
            this.currentRole = role;
            this.getRoleModules();
        });
    }
    this.success = false;
  }

  setModules(module_id: number, checked){
    if(checked){
      this.choixModules.push(module_id);
    }else{
      this.choixModules = this.choixModules.filter(num => num !== module_id);
    }
  }

  onFormSubmit(){
    if(this.selectedModules.length > 0){
      this.roleService.savePermissions(this.currentRole.id, this.choixModules).subscribe((response) => {
        this.success = true;

        this._userService.user$
          .subscribe((user: User) => {
            if(user.role_id == this.currentRole.id){
              location.reload(); // Rafraichit la page si le role changer est celui de l'utilisateur
            }
          });
      }, (error) => { this.showErrors(error); });
    }
  }

  checkIfAccess(id_module: number): boolean{
    let checked = false;
    this.selectedModules.forEach((module) => {
      if(id_module == module.module_id){
        checked = true;
      }
    });

    return checked;
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  showErrors(error: any) {
    //Gestion des erreurs laravel
    if (error instanceof HttpErrorResponse) {
        for (const key in error.error.errors) {
            //Todo: handle error
        }
    }
    else {
        error.forEach((element) => {
            //this.toastr.error(element);
        });
    }
  }
}
